import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { organizationsList } from "../../services/organizations";
import useAuthContext from "../../providers/authProvider";

const OrganizationsList = () => {
  const { t } = useTranslation();
  const [organizations, setOrganizations] = useState([]);

  useEffect(() => {
    const fetchOrganizationFromCookie = async () => {
      const { organizations } = await organizationsList();
      setOrganizations(organizations);
    };
    fetchOrganizationFromCookie();
  }, []);

  return (
    <div className="switch-clubs">
      <div className="switch-clubs-container">
        <h1 className="switch-clubs-container-header">{t("organization.title")}</h1>
        <div className="cards-block">
          {organizations?.map((organization, id) => (
            <OrganizationCard key={id} organization={organization} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default OrganizationsList;

const OrganizationCard = ({ organization }) => {
  const { t } = useTranslation();
  const { setOrganization } = useAuthContext();
  const navigate = useNavigate();

  const selectOrganization = async (orgId) => {
    if (!orgId) return;
    Cookies.set("organization_id", orgId);
    await setOrganization();
    navigate(`/club_admin/organization`);
  };

  return (
    <div className="club-box">
      <div className="club-box-body">
      <div className="club-box-body-title">{organization.name}</div>
        <div className="logo-image">
          <img src={organization?.logo} alt="Organization Logo" />
        </div>
        
      </div>
      <div className="club-box-footer">
        <button className="button button-primary full-width" onClick={() => selectOrganization(organization.id)}>
          {t("organization.switch.select_organization")}
        </button>
      </div>
    </div>
  );
};
